// extracted by mini-css-extract-plugin
export default {"main":"Amount_main__UkJ+Q","flag":"Amount_flag__fJrT7","select":"Amount_select__p2PV6","input_box":"Amount_input_box__AY5ur","input":"Amount_input__Zu6gB"};